import { HierarchyLevel } from '../dtc-commerce-mmm-types';
import { ChannelIcon } from './ChannelIcon';
import { IncrementalityBeaker } from './IncrementalityBeaker';
import { MediaTypeBadge, MediaTypeBadgeVariant } from './MediaTypeBadge';

interface ChannelTooltipSubheaderProps {
  channel: string;
  platform?: string;
  mediaType?: string;
  hierarchyLevel: HierarchyLevel;
  hasIncrementalityTest?: boolean;
}

export const ChannelTooltipSubheader = ({
  channel,
  platform,
  mediaType,
  hierarchyLevel,
  hasIncrementalityTest = false
}: ChannelTooltipSubheaderProps) => (
  <div className='dtc-commerce-mmm-channel-tooltip-subheader'>
    <ChannelIcon channel={channel} platform={platform} level={hierarchyLevel} size={16} />
    {mediaType && <MediaTypeBadge mediaType={mediaType} variant={MediaTypeBadgeVariant.SHORT} />}
    {hasIncrementalityTest && <IncrementalityBeaker size={16} />}
  </div>
);
